import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { AppRoutes, MODAL_TOKEN, ModalProvider, ProfileRoutes } from '@core';
import { Router } from '@angular/router';

@Component({
  selector: 'lib-push-achievements',
  templateUrl: './push-achievements.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true
})
export class PushAchievementsComponent {
  private readonly modalProvider: ModalProvider = inject(MODAL_TOKEN);
  private readonly router: Router = inject(Router);

  handleAction(): void {
    this.modalProvider.dismissAllStoredModals();
    this.router.navigateByUrl(`${AppRoutes.PROFILE}/${ProfileRoutes.ALL_TROPHIES}`);
  }

  closeModal(): void {
    this.modalProvider.dismissAllStoredModals();
  }
}
